class ThemeHeader extends HTMLElement {
  constructor() {
    super();
    this.headerInner = this.querySelector('.header--inner');
    // Read settings
    this.customSticky = this.dataset.customSticky === 'true';
    this.headerHeight = 0;
    this.lastScrollTop = 0;
    
    this.onScroll = this.onScroll.bind(this);
    this.measureHeight = this.measureHeight.bind(this);

    if (this.customSticky || this.dataset.stickyEnabled === 'true') {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.measureHeight);
      setTimeout(this.measureHeight, 500);
    }
  }

  measureHeight() {
    if (this.headerInner) {
      this.headerHeight = this.headerInner.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      
      const placeholder = document.querySelector('.custom-header-placeholder');
      if (placeholder) placeholder.style.height = `${this.headerHeight}px`;
    }
  }

  onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    
    // Top of page: Reset
    if (scrollTop <= 0) {
      this.classList.remove('is-sticky-custom', 'scroll-down-hidden', 'scroll-up-visible');
      const placeholder = document.querySelector('.custom-header-placeholder');
      if(placeholder) placeholder.style.display = 'none';
      this.lastScrollTop = 0;
      return;
    }

    if (this.customSticky) {
      const threshold = this.headerHeight + 20;

      if (scrollTop > threshold) {
        this.classList.add('is-sticky-custom');
        
        const placeholder = document.querySelector('.custom-header-placeholder');
        if(placeholder) placeholder.style.display = 'block';

        if (scrollTop > this.lastScrollTop) {
          // DOWN
          this.classList.add('scroll-down-hidden');
          this.classList.remove('scroll-up-visible');
        } else {
          // UP
          this.classList.remove('scroll-down-hidden');
          this.classList.add('scroll-up-visible');
        }
      }
    } 
    else if (this.dataset.stickyEnabled === 'true') {
       if (scrollTop > this.headerHeight) {
         this.classList.add('header-sticky--active');
       } else {
         this.classList.remove('header-sticky--active');
       }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
}

customElements.define('theme-header', ThemeHeader);